import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Prevent mouse-wheel from accidentally changing the value of a focused number
// input — blur it on scroll so the value stays put and the page scrolls normally.
document.addEventListener(
  "wheel",
  () => {
    const el = document.activeElement;
    if (el && el.tagName === "INPUT" && el.type === "number") {
      el.blur();
    }
  },
  { passive: true }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
